// for alert message with dynamic message
import { toast } from 'react-toastify';
import { debounce } from 'lodash';

let debouncedNotify = null;

const showToast = (message, type, autoCloseTime) => {
    if (!debouncedNotify) {
        toast[type](message, {
            position: "top-center",
            autoClose: autoCloseTime,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: false,
            progress: 0,
            theme: "light",
        });

        debouncedNotify = debounce(() => {
            debouncedNotify = null;
        }, autoCloseTime);

        debouncedNotify();
    } else {
        debouncedNotify();
    }
};
// FOR MESSAGE WITH DOT
const formatDotMessage = (message, data = {}) => {
    let dotMessage = `• ${message}`;
    if (data && typeof data === 'object') {
        Object.entries(data).forEach(([key, value]) => {
            if (value) {
                dotMessage += `\n• ${key}: ${value}`;
            }
        });
    }
    return dotMessage;
};
const ErrorToast = (message, isDotMsg = false, data = {}) => {
    if (isDotMsg) {
        const dotMsg = formatDotMessage(message, data);
        return showToast(dotMsg, "error", 2000);
    } else {
        return showToast(message, "error", 2000);
    }
};

const SuccessToast = (message) => {
    showToast(message, "success", 2000);
};

const InfoToast = (message) => {
    showToast(message, "info", 3000);
};

export { ErrorToast, SuccessToast, InfoToast };
